export default __webpack_public_path__ + "static/media/Wolf's Chestguard of the Howling Moon.a599b0f9.jpg";